import React, { Component } from 'react'
import {
    setTVConformPage,
    setAdminPage,
    roomSelectorStatus
} from '../../action/action'

import { setCurrentTV } from '../../action/tvChannelAction'
import { connect } from 'react-redux'
import { conformationColorSet } from '../../JS/setColors'

class conformPage extends Component {
    onYesClick = () => {
        this.props.setTVConformPage(false);
        this.props.setCurrentTV(this.props.nextTV);
    }

    onNoClick = () => {
        this.props.setTVConformPage(false);
    }

    componentDidMount() {
        conformationColorSet(this.props.menuColor);
    }
    
    render() {
        return (
            <div className="overlay">
                <div id="svc" className="overlay-body">
                    <div className="primary-response center" style={{ color: "inherit" }}>
                        <div className="wide" style={{ fontSize: '20px', color: "inherit" }}>
                            Are you sure you want to change TV?
                        </div>
                        <button className="btn-yes" onClick={() => { this.onYesClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.yes}
                        </button>
                        <button className="btn-no" onClick={() => { this.onNoClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.no}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor,
        nextTV: state.store.tvChannels.nextTV
    }
}
export default connect(
    mapStateToProps,
    {
        setTVConformPage,
        setAdminPage,
        roomSelectorStatus,
        setCurrentTV
    }
)(conformPage);